import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import AxiosClient from "./../client/AxiosClient";
import { API_TICKER } from "./../ApiEndPoints";

export default function MarqueeHome() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const serverUrl = process.env.REACT_APP_SERVER_BASE_URL;

  useEffect(() => {
    AxiosClient.get(API_TICKER)
      .then((response) => {
        const listData = response.data.data;

        setData(listData);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    data.length > 0 && (
      <section className="bg-light py-0">
        <div className="container">
          <Marquee
            className="home_marquee py-2"
            pauseOnHover={true}
            speed={120}
          >
            {data.map((elm, index) => {
              return (
                <>
                  <a href={elm.link} target="_blank" id={`ticker-${index}`}>
                    {elm.label}
                  </a>{" "}
                  <span className="px-2"> | </span>
                </>
              );
            })}
          </Marquee>
        </div>
      </section>
    )
  );
}
